import {userStorage} from "../../utils/localStorage/userStorage";
import {useNavigate} from "react-router-dom";


const RedirectHomePage = () => {
    const navigate = useNavigate()
    const isLoggedIn = !!userStorage.get()
    !isLoggedIn ? navigate('/login') : navigate('/solicitudes')
    
    return (
        <>
        </>
    )
}


export default RedirectHomePage